export default __webpack_public_path__ + "static/media/washingmachine.b35dec49.jpg";